<template>
  <base-card v-if="!loading" :condensed="!responsive.lg">
    <div class="row  py-2 text-center d-flex justify-content-between align-items-center h-100">
      <base-hover
        v-for="(entry, index) in events"
        :key="`emailStat_${entry.name}`"
        v-slot="{isHover}"
        class="col clickable"
      >
        <div @click="$emit('click', index);">
          <base-text light class="name">
            {{ entry.name }}
          </base-text>

          <base-text
            size="lg"
            class="text-center"
          >
            <span
              :class="`d-inline-block stat-value ${isHover ? 'stat-value--underlined' : ''}`"
            >
              {{ entry.value }}
            </span>
          </base-text>
        </div>
      </base-hover>
    </div>
  </base-card>
</template>

<script>
import responsive from '@/components/mixins/responsive';

export default {
  name: 'EventsSummary',
  mixins: [responsive],
  props: {
    events: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    outreachId: {
      type: [String, Number],
      required: true,
    },
  },
};
</script>
<style lang="scss" scoped>
  ::v-deep .card-body {
    height: 100%;
  }
  .name {
    font-size: 15px;
  }
  .stat-value {
    min-width: 30px;
    border-bottom: 1px solid transparent;

    &--underlined {
      border-bottom: 1px solid $black;
    }
  }
</style>
